import {getFlattenedNodes} from '@ls/grouping-service';
import {memoize, uniqueByKey} from '@ls/js-utils';
import {createSelector} from 'reselect';
import SelectionState from 'state/selections/SelectionState';
import scope from './scope';

export const selectSecurityAttributesData = state => state[scope]['securityAttributesData'];
export const selectFetchingSecurityAttributesData = state => state[scope]['fetchingSecurityAttributesData'];
export const selectSecurityAttributesOptions = state => state[scope]['securityAttributesOptions'];
export const selectFetchingSecurityAttributesOptions = state => state[scope]['fetchingSecurityAttributesOptions'];

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return state => state[scope]['definitions'][selectionState];
  }

  return createSelector(
    state => state[scope]['definitions'][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(({complete}) => complete);
      return completeDefinitions.filter(uniqueByKey(completeDefinitions, 'key'));
    },
  );
});

export const selectRowMap = createSelector(
  selectDefinitions(SelectionState.COMMITTED),
  selectSecurityAttributesData,
  (definitions, secAttributesData) => {

    const nodes = getFlattenedNodes(secAttributesData?.root) ?? [];
    const secAttribsById = secAttributesData?.securityAttributes?.reduce((map, secAttribs) => {
      map[secAttribs.primaryKey.securityId] = {
        ...secAttribs,
        repSecId: secAttribs.primaryKey.securityId,
      };
      return map;
    }, {});
    return nodes
      .filter(({securityId}) => securityId)
      .reduce((rowMap, node) => {
      const {pathString} = node;
      rowMap[pathString] = rowMap[pathString] ?? {pathString};
      const row = rowMap[pathString];
      definitions
        .filter(({key}) => !row[key])
        .forEach((definition) => {
          const secAttribs = secAttribsById[node.securityId];
          row[definition.key] = secAttribs?.[definition.attribute] ?? null;
        });
      return rowMap;
    }, {});
  },
);

